import { AutogenLayoutBrokeragePlanningProfileFilter } from "./autogen/AutogenLayoutBrokeragePlanningProfileFilter";
import { BrokeragePlanningProfile } from "./BrokeragePlanningProfile";

export class BrokeragePlanningProfileFilter extends AutogenLayoutBrokeragePlanningProfileFilter {

    override onLoad() {
        const profileLayout = this.layoutProfile as BrokeragePlanningProfile;
        profileLayout.textboxTitle.required = false;
        profileLayout.textboxBrkQualProfile.visible = false;
        profileLayout.textboxBrkQualStatus.visible = false;
        profileLayout.switchExactLaneMatch.visible = false;
        profileLayout.textboxDefaultOriginFilter.visible = false;
        profileLayout.textboxDefaultDestFilter.visible = false;
        profileLayout.textboxIntSearchProfileId.visible = false;
    }
}
